import { Constants } from './../shared/Helpers/constants';
import { Component, OnInit } from '@angular/core';
import { User } from '../_models/index';
import { AuthenticationService } from '../_services/index';
import { Router } from '../../../node_modules/@angular/router';
import { UserContext } from '../_context/user.context';
import { environment } from '@env/environment';

@Component({
  moduleId: module.id,
  templateUrl: 'home.component.html'
})
export class HomeComponent implements OnInit {
  public currentUser: User | any;
  public users: User[] = [];
  public returnUrl: any;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private userContext: UserContext
  ) {
    this.currentUser = JSON.parse(localStorage.getItem(Constants.localStorage_currentUser));
  }

  ngOnInit() {
    if (localStorage.getItem(Constants.localStorage_currentUser)) {
      this.returnUrl = environment.default_return_url;
      if (this.userContext.isAuthenticated && this.userContext.userID && this.userContext.organisationID) {
        this.authenticationService.redirect(this.returnUrl)
      } else {
        this.router.navigate(['logout']);
      }
    } else {
      this.router.navigate(['login']);
    }
  }
}
